
import { Component, Vue } from 'vue-property-decorator'
import NumberedCardSection from '@/components/NumberedCardSection.vue'
import InfoBlock from './components/InfoBlock.vue'
import CommentBlock from './components/CommentBlock.vue'

@Component({ components: { NumberedCardSection, InfoBlock, CommentBlock } })
export default class ShareCoupons extends Vue {
  readonly rules = ['活動狀態校驗', '領取資格校驗', '領取上限校驗']
  readonly scenarios = [
    {
      title: '門店掃碼',
      image: 'https://spics.inctrip.com/cb8b26dd877672439d4562f158b93377.png',
      description: '客人喺門口見到 QR Code，掃一掃直接跳入呢間店嘅首頁，唔使揀門店、唔使撈亂。',
      destination: '直接跳轉 → 對應門店首頁',
    },
    {
      title: '社交分享',
      image: 'https://spics.inctrip.com/3a6c83d700a6415f17c04c902752002b.png',
      description: 'WhatsApp / Facebook 收到朋友轉發嘅優惠，按位置智慧推薦最近嘅門店，就近去食。',
      destination: '跳轉 → 門店列表 + 位置推薦',
    },
    {
      title: '單店品牌',
      image: 'https://spics.inctrip.com/b1030d151668b7f4d2b83e39a151c041.png',
      description: '得一間店？連門店頁都慳返，拎完券直接跳入菜單，一步到位，最快落單。',
      destination: '直接跳轉 → 對應門店首頁',
    },
  ]
  readonly cards = [
    {
      eyebrow: 'Multi-Channel Distribution',
      title: '全渠道鋪開發券有客人嘅地方就有著數',
      bullets: [
        'WhatsApp 一click即send',
        'Facebook 帳號引流吸粉',
        '門店 QR Code 掃碼即拎',
      ],
      description: '無論客人鍾意用 WhatsApp 傾計、Facebook 睇資訊，定係行過門口見到 QR Code，都可以隨時隨地拎優惠。唔使裝 App、唔使註冊先，點擊即刻入領券流程，參與門檻幾乎為零。二次分享自動記來源，邊條渠道最有效，一目了然。',
      image: 'https://spics.inctrip.com/cb69c30f270d0905a88ba9818c9f3a1a.png',
      color: '#fff7ee',
    },
    {
      eyebrow: 'Multiple Login Methods',
      title: '支援多種快捷登入方式滿足不同顧客使用習慣',
      bullets: [
        '電郵 / 手機號 簡單驗證',
        'Google / Facebook 一click登入',
        'WeChat 小程序 靜默拎券',
      ],
      description: '年輕人鍾意 Google、Facebook 一click登入，熟客習慣用電郵手機，大灣區客愛用 WeChat——五種登入方式任揀，唔駛就住系統。新客自動開帳號、舊客一秒驗證，拎券即時到手。次數同資格系統自動把關，唔怕有人重複領、亂領。',
      image: 'https://spics.inctrip.com/0607bc714d43e6ac16940c93a9342c9f.png',
      color: '#fffaec',
    },
    {
      eyebrow: 'In-App Coupon Popup',
      title: '點餐頁彈窗送驚喜本來睇吓睇吓，結果即刻落單',
      bullets: [
        '彈窗款式自由揀',
        '拎完即扣，即買即用',
        '時間同次數完全話事',
      ],
      description: '客人喺菜單頁揀緊嘢食，彈出一張限時優惠券——節日優惠、新品嚐鮮、會員專享，統統都做到。拎完自動跳入菜單，折扣即時見到，本來仲諗諗吓嘅客人，即刻變消費者。普通客同會員分層推，每一分預算都用得最盡。',
      image: 'https://spics.inctrip.com/88616111715fa08d24e8ce3ccdc9c252.png',
      color: '#f0f9ff',
    },
    {
      eyebrow: 'Admin Dashboard',
      title: '後台自己話晒事五分鐘搞掂一場活動',
      bullets: [
        '活動日期同券包自由配',
        '邊啲人有得拎 自己話事',
        '領券連結 一click複製',
      ],
      description: '想做優惠？唔使搵 IT、唔使等設計。品牌級後台「品牌活動管理」度，由開活動、揀券包、設規則到出連結，全部視覺化操作，睇得明、點得快。營運同事五分鐘就搞掂一場活動，想幾時做就幾時做。',
      image: 'https://spics.inctrip.com/b13d9932eb07f8375a24171cd4c7edd9.png',
      color: '#fef8f6',
    },
  ]
}
